export enum ECabinetGeneratorErrorCode
{
    /// <summary>
    /// The total width of the front elements is greater than the face width
    /// </summary>
    FrontElementWidthOverflowing,
    /// <summary>
    /// The total height of the front elements is greater than the face height
    /// </summary>
    FrontElementHeightOverflowing,

    /// <summary>
    /// The total width of the front elements is smaller than the face width
    /// We admit a 1cm margin 
    /// </summary>
    FrontElementWidthInsufficient,
    /// <summary>
    /// The total height of the front elements is smaller than the face height
    /// We admit a 1cm margin
    /// </summary>
    FrontElementHeightInsufficient,
}